const faqEntities = $('.faq-entity');
const faqEntitiesObj = [];
let lastOpenedIndex = undefined;

const setCard = (index) => {
  const card = faqEntitiesObj[index].card;
  const cardTopper = card.find('.faq-entity-topper');
  const cardTopperHeight = pxToVw(cardTopper.outerHeight());
  gsap.set(card, { height: `${cardTopperHeight}vw` });
};

const toggleCard = (index) => {
  const card = faqEntitiesObj[index].card;
  const cardTopper = card.find('.faq-entity-topper');
  const cardContent = card.find('.faq-entity-content');
  const cardBtnIcon = card.find('.faq-entity-icon');
  const cardTopperHeight = pxToVw(cardTopper.outerHeight());
  const cardContentHeight = pxToVw(cardContent.outerHeight());
  const cardOpened = faqEntitiesObj[index].isOpened;
  gsap.to(cardBtnIcon, {
    rotate: cardOpened ? 90 : 270,
    duration: 0.67,
    ease: 'pageInEasing',
  });
  gsap.to(card, {
    height: cardOpened ? `${cardTopperHeight}vw` : `${cardTopperHeight + cardContentHeight}vw`,
    duration: 0.67,
    ease: 'pageInEasing',
  });
  gsap.to(cardContent, {
    opacity: cardOpened ? 0 : 1,
    y: cardOpened ? '1vw' : 0,
    duration: 0.67,
    ease: 'pageInEasing',
    onComplete: () => {
      ScrollTrigger.refresh();
    },
  });
  faqEntitiesObj[index].isOpened = !faqEntitiesObj[index].isOpened;
  !cardOpened ? (lastOpenedIndex = index) : false;
};

const setFAQCards = () => {
  faqEntities.each(function (index) {
    const card = $(this);
    faqEntitiesObj[index] = { card: card, isOpened: false };
    setCard(index);
  });
};

const addCardsControl = () => {
  faqEntities.each(function (index) {
    const cardBtn = $(this).find('.faq-entity-icon-parent');
    const cardFeedbackParent = $(this).find('.faq-entity-feedback-like-group');

    faqEntitiesObj[index].card.on('click', function () {
      if (lastOpenedIndex == index && faqEntitiesObj[index].isOpened) {
        lastOpenedIndex = undefined;
      }
      if (lastOpenedIndex != undefined && lastOpenedIndex != index) {
        toggleCard(lastOpenedIndex);
        faqEntitiesObj[lastOpenedIndex].isOpened = false;
      }
      toggleCard(index);
    });

    cardFeedbackParent.on('click', function (e) {
      e.stopPropagation();
    })
  });
};


$(window).on('deviceChange', () => {
  setFAQCards();
});

$(window).on('load', () => {
  setFAQCards();
  addCardsControl();
});
